import { Component, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ThankModalComponent } from '../thank-modal/thank-modal.component';
import { BillingService } from '../../../../../../shared/services/billing.service';
import { ClickhouseService } from '../../../../../../shared/services/clickhouse.service';

@Component({
  selector: 'app-tips-modal',
  templateUrl: './tips-modal.component.html',
  styleUrls: ['./tips-modal.component.scss'],
})
export class TipsModalComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    public billingService: BillingService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private clickHouseService: ClickhouseService,
  ) {}

  ngOnInit(): void {
    this.clickHouseService.storeEvent('tips_popup_shown').subscribe(() => {});
  }

  purchasePlan(productUuid: string, range: string) {
    this.spinner.show();
    combineLatest([
      this.billingService.purchaseSolution(productUuid),
      this.clickHouseService.storeEvent(`tips_${range}_button_click`),
    ]).subscribe(([purchaseResponse]: any) => {
      if (purchaseResponse.status === 'error') {
        import('../../../../../../components/modals/payform/payform-component.module').then(
          ({ PayformComponentModule }) => {
            const PayformComponent = PayformComponentModule.getComponent();
            const payFormInstance = this.modalService.open(PayformComponent);
            payFormInstance.componentInstance.product = productUuid;
          },
        );
      } else {
        this.modalService.open(ThankModalComponent, {
          backdrop: 'static',
          keyboard: false,
          centered: true,
        });
      }
      this.activeModal.dismiss('Cross click');
      this.spinner.hide();
    });
  }

  thanks() {
    this.activeModal.dismiss('Cross click');
    this.clickHouseService.storeEvent('tips_skip_click').subscribe(() => {});
  }
}
